import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';

@Injectable()
export class CommonModalService {

	// Default options for modal
	private _modalOptions: MatDialogConfig = {
		height: '90%',
		width: '900px'
	};
	// Default options for small modal like confirm modal
	private _confirmModalOptions: MatDialogConfig = {
		height: '200px',
		width: '480px'
	};
	constructor(
		public dialog: MatDialog
	) { }

	get modalOptions() {
		return Object.assign({}, this._modalOptions);
	}
	get confirmModalOptions() {
		return Object.assign({}, this._confirmModalOptions);
	}

	openModalWindow(modalComponent, options?: MatDialogConfig, successCallback?, errorCallback?) {
		options = options || {};
		const dialogRef = this.dialog.open(modalComponent, {
			width: options.width || this.modalOptions.width,
			height: options.height || this.modalOptions.height,
			data: options.data
		});
		dialogRef.afterClosed()
		.catch(errorCallback)
		.subscribe(successCallback);
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/common-modal.service.ts